import React, { Component } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import TextQuestion from "../../components/TextQuestion";
import PostcodeLookup from "../../components/PostcodeLookup";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";
import { signupPriceError } from "./signupPrice";

class SellingAddressDetails extends Component {
  constructor(props) {
    super(props);

    if (this.props.sellingAddressDetails) {
      const details = this.props.sellingAddressDetails;
      this.state = {
        price: details.price,
        propertyAddress: { ...details.propertyAddress },
        errors: { ...details.errors },
      };
    } else {
      this.state = {
        propertyAddress: {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressTown: "",
          addressCounty: "",
          addressPostcode: "",
        },
        price: "",
        errors: {},
      };
    }
  }

  handleValidation() {
    const fields = { ...this.state };

    let errors = {};
    let formIsValid = true;

    if (!fields.propertyAddress["addressLine1"]) {
      const field = "addressLine1";
      formIsValid = false;
      errors[field] = true;
    }

    if (!fields.propertyAddress["addressTown"]) {
      const field = "addressTown";
      formIsValid = false;
      errors[field] = true;
    }

    if (!fields.propertyAddress["addressPostcode"]) {
      const field = "addressPostcode";
      formIsValid = false;
      errors[field] = true;
    }

    const priceError = signupPriceError(fields["price"]);
    if (priceError) {
      formIsValid = false;
      errors["price"] = priceError;
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleAddressFieldValidation = (field) => (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      let errors = { ...prevState.errors };
      const errorMessages = { ...prevState.errorMessages };

      if (isBlur) {
        if (!prevState.propertyAddress[field]) {
          errors[field] = errorMessages[field];
        }
      } else {
        errors[field] = null;
      }

      return { errors };
    });
  };

  handlePriceFieldValidation = (field) => (event) => {
    const error = event.type === "blur" ? signupPriceError(event.target.value) : null;
    this.setState((prevState) => ({ errors: { ...prevState.errors, [field]: error } }));
  };

  priceEntered = (p) => {
    this.setState({ price: p });
  };

  handleAddressChange = (field) => (event) => {
    let propertyAddress = { ...this.state.propertyAddress };
    propertyAddress[field] = event;
    this.setState({ propertyAddress });
  };

  saveSellingAddressDetails = (event) => {
    event.preventDefault();
    if (this.handleValidation()) {
      this.props.onStepComplete({
        sellingAddressDetails: {
          propertyAddress: this.state.propertyAddress,
          price: this.state.price,
        },
      });
      return;
    }
  };

  addressSelected = (address) => {
    this.setState((prevState) => ({
      propertyAddress: { ...prevState.propertyAddress, ...address },
      errors: { ...prevState.errors, addressLine1: null, addressTown: null, addressPostcode: null },
    }));
  };

  render() {
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="What's the property address?" removeTopPadding>
          <PostcodeLookup
            address={this.state.propertyAddress}
            errors={this.state.errors}
            onAddressSelected={this.addressSelected}
          >
            <TextQuestion
              question="Address line 1"
              value={this.state.propertyAddress.addressLine1 || ""}
              valueEntered={this.handleAddressChange("addressLine1")}
              validate={this.handleAddressFieldValidation("addressLine1")}
              validationError={this.state.errors.addressLine1 ? "Enter the first line of the address" : null}
            />

            <TextQuestion
              question="Address line 2"
              optional={true}
              value={this.state.propertyAddress.addressLine2 || ""}
              valueEntered={this.handleAddressChange("addressLine2")}
            />

            <TextQuestion
              question="Address line 3"
              optional={true}
              value={this.state.propertyAddress.addressLine3 || ""}
              valueEntered={this.handleAddressChange("addressLine3")}
            />

            <TextQuestion
              question="Town"
              value={this.state.propertyAddress.addressTown || ""}
              valueEntered={this.handleAddressChange("addressTown")}
              validate={this.handleAddressFieldValidation("addressTown")}
              validationError={this.state.errors.addressTown ? "Enter the town" : null}
            />

            <TextQuestion
              question="County"
              optional={true}
              value={this.state.propertyAddress.addressCounty || ""}
              valueEntered={this.handleAddressChange("addressCounty")}
            />

            <TextQuestion
              question="Postcode"
              size="small"
              value={this.state.propertyAddress.addressPostcode || ""}
              valueEntered={this.handleAddressChange("addressPostcode")}
              validate={this.handleAddressFieldValidation("addressPostcode")}
              validationError={this.state.errors.addressPostcode ? "Enter the postcode" : null}
            />
          </PostcodeLookup>

          <TextQuestion
            question={
              this.props.propertyOfferAccepted
                ? "How much have you agreed to sell it for?"
                : "What’s your asking price?"
            }
            size="large"
            inputMode="numeric"
            value={this.state.price || ""}
            valueEntered={this.priceEntered}
            validate={this.handlePriceFieldValidation("price")}
            validationError={this.state.errors.price || null}
          />

          <Action onClick={this.saveSellingAddressDetails}>Continue</Action>
        </Card>
        <Image src={imageCatAndHousePlant} />
      </React.Fragment>
    );
  }
}

export default SellingAddressDetails;
